import React from 'react';

import ProductExStock from '../components/product-ex-stock';

class ProductExStockPage extends React.Component{
  render() {
    return (
      <div>
        <ProductExStock />
      </div>
    )
  }
}

export default ProductExStockPage;


// WEBPACK FOOTER //
// ./src/containers/product-ex-stock-page.js